import {Component, Input} from '@angular/core';
import {Belastungsstufe} from '../../../../../../../../../model/vorhersagen/pollenflug';

@Component({
  selector: 'app-pollenflug-belastungsstufe',
  templateUrl: './pollenflug-belastungsstufe.component.html',
  styleUrls: ['./pollenflug-belastungsstufe.component.css']
})
export class PollenflugBelastungsstufeComponent {

  @Input()
  belastungsstufe: Belastungsstufe;

  visualizeBelastungsstufe(belastungsstufe: string): string {
    switch (belastungsstufe) {
      case '0':
        return 'keine-belastung';
      case '0-1':
        return 'keine-bis-geringe-belastung';
      case '1':
        return 'geringe-belastung';
      case '1-2':
        return 'geringe-bis-mittlere-belastung';
      case '2':
        return 'mittlere-belastung';
      case '2-3':
        return 'mittlere-bis-hohe-belastung';
      case '3':
        return 'hohe-belastung';
      default:
        return 'unknown';
    }
  }

}
